import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';

import { SharedModule } from './../../../private/shared/modules/shared.module';
import { SpamMoreProductsPage } from './spam-more-products.page';

@NgModule({
  imports: [
    CommonModule,
    FormsModule,
    IonicModule,
    SharedModule,
    TranslateModule,
  ],
  declarations: [SpamMoreProductsPage]
})
export class SpamMoreProductsPageModule {}
